import { BrowserRouter, Routes, Route, useRoutes } from "react-router-dom";

import Initor from '../pages/init'
import Home from "../pages/index";
import Unauthorized from "../pages/unauthorized";
import Layout from '../pages/layout'
import CourseList from '../pages/course'
import CourseSeries from '../pages/course/series'
import CourseSingle from '../pages/course/single'
import StudentList from '../pages/student'
import TeacherIndex from '../pages/teacher'
import TeacherUpdate from '../pages/teacher/update'
import AttendList from '../pages/school'
import SchoolGallery from '../pages/school/gallery'
import SchoolUpdate from '../pages/school/update'
import JobfairList from '../pages/jobfair'
import JobfairUpdate from '../pages/jobfair/update'


export default function() {
  let element = useRoutes([
    {
      path:'/',
      element: <Initor />
    },
    {
      path: '/unauthorized',
      element: <Unauthorized />
    },
    {
      path: 'home',
      element: <Layout />,
    },
    {
      path: 'course',
      element: <Layout />,
      children:[{
        path: 'list',
        element: <CourseList />
      },{
        path: 'single/create',
        element: <CourseSingle />
      },{
        path: 'single/:id',
        element: <CourseSingle />
      },{
        path: 'series/create',
        element: <CourseSeries />
      },{
        path: 'series/:id',
        element: <CourseSeries />
      }]
    },
    {
      path: 'student',
      element: <Layout />,
      children:[{
        path: 'list',
        element: <StudentList />
      }]
    },{
      path: 'teacher',
      element: <Layout />,
      children:[{
        path: 'list',
        element: <TeacherIndex />
      },{
        path: 'create',
        element: <TeacherUpdate />
      },{
        path: ':id',
        element: <TeacherUpdate />
      }]
    },
    {
      path: 'school',
      element: <Layout />,
      children:[
      {
        path: 'list',
        element: <AttendList />
      },
      {
        path: 'gallery',
        element: <SchoolGallery />
      },
      {
        path: ':id',
        element: <SchoolUpdate />
      }
    ]},
    {
      path: 'jobfair',
      element: <Layout />,
      children:[
        {
          path: 'list',
          element: <JobfairList />
        },

        {
          path: ':id',
          element: <JobfairUpdate />
        }
      ]}
  ])

  return element;
}
